/**
 * ScrollToTop - Scrollar till toppen vid navigation
 *
 * Lyssnar på route-ändringar och scrollar smidigt till toppen av sidan.
 * Använder smooth scroll för en trevlig användarupplevelse.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Kolla om användaren är nedscrollad
    const isScrolled = window.scrollY > 0;

    if (isScrolled) {
      // Smooth scroll till toppen om nedscrollad
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // Instant scroll om redan nära toppen (för snabbare upplevelse)
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
